import {Chip} from "@heroui/chip";
import React from "react";

export function LiveChip({ classNames }) {
    return <Chip className="bg-red-" variant="dot" classNames={{...classNames, dot: "animate-pulse bg-red-500"}}>Live stream</Chip>
}